<template>
    <b-modal
        hide-footer
        modal-class="email-attachment-modal"
        size="lg"
        title="Anhänge"
        :visible="show && emailId !== null"
        @hidden="$emit('hidden')">
        <div v-if="isLoading" class="d-flex justify-content-center pt-4">
            <csp-loading-indicator/>
        </div>
        <div v-if="!isLoading">
            <b-alert
                v-if="attachments.length === 0"
                show
                variant="info">
                Diese E-Mail enthält keine herunterladbaren Anhänge.
            </b-alert>
            <b-table
                v-else
                borderless
                :fields="tableFields"
                :items="attachments"
                responsive
                striped>
                <template v-slot:cell(actions)="{ item }">
                    <div class="table-actions d-flex">
                        <a
                            :href="openAttachmentUrl(item)"
                            target="_blank"
                            title="In neuem Tab öffnen">
                            <i class="inticon-autoclaim_detail"/>
                        </a>
                        <a
                            :href="downloadAttachmentUrl(item)"
                            target="_blank"
                            title="Herunterladen">
                            <i class="inticon-autoclaim_einzeldownload"/>
                        </a>
                    </div>
                </template>
            </b-table>
        </div>
    </b-modal>
</template>

<script>
import '@desktop/scss/components/digital-mailbox.scss';
import Container from '@services/Container';
import LoadingIndicator from '@components/LoadingIndicator';

const container = Container.getInstance();
const digitalMailboxRepository = container.getDigitalMailboxRepository();

export default {
    name: 'EmailAttachmentModal',
    components: {
        'csp-loading-indicator': LoadingIndicator,
    },
    props: {
        emailId: {
            default: null,
            type: String,
        },
        show: {
            required: true,
            type: Boolean,
        },
    },
    emits: ['hidden'],
    data() {
        return {
            attachments: [],
            isLoading: false,
            tableFields: [
                {key: 'name', label: 'Dateiname'},
                {key: 'fileType', label: 'Dateityp'},
                {key: 'size', label: 'Größe'},
                {key: 'actions', label: 'Aktionen'},
            ],
        };
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this._loadAttachments();
            }
        },
    },
    methods: {
        downloadAttachmentUrl(item) {
            return digitalMailboxRepository.buildAttachmentUrl(
                this.emailId,
                item.actions.emailAttachmentId,
                'attachment'
            );
        },
        openAttachmentUrl(item) {
            return digitalMailboxRepository.buildAttachmentUrl(
                this.emailId,
                item.actions.emailAttachmentId,
                'inline'
            );
        },
        _loadAttachments() {
            if (!this.emailId) {
                return;
            }
            this.isLoading = true;
            this.attachments = [];
            digitalMailboxRepository.loadEmailAttachments(this.emailId)
                .then((attachments) => {
                    this.attachments = attachments;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>
